import { Card, Text } from '@/design-system'
import type { TextTone } from '@/design-system'

export interface Stat {
  readonly label: string
  readonly value: string
  readonly note?: string
  readonly tone?: TextTone
}

export function StatTile({ stat }: { readonly stat: Stat }) {
  return (
    <Card tone="light">
      <Text variant="eyebrow" weight="semibold" tone="secondary">
        {stat.label}
      </Text>
      <Text as="p" variant="heading" weight="bold" numeric tone={stat.tone ?? 'primary'} className="pb-mt-2">
        {stat.value}
      </Text>
      {stat.note && (
        <Text variant="eyebrow" tone="secondary" className="pb-mt-2">
          {stat.note}
        </Text>
      )}
    </Card>
  )
}
